import { render, staticRenderFns } from "./ProctoringSession.vue?vue&type=template&id=22b7e163&scoped=true&"
import script from "./ProctoringSession.vue?vue&type=script&lang=js&"
export * from "./ProctoringSession.vue?vue&type=script&lang=js&"
import style0 from "./ProctoringSession.vue?vue&type=style&index=0&id=22b7e163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7e163",
  null
  
)

export default component.exports